/* "Included" catalogue groups on outfits: pick one item from the catalogue (or a tile), no charge, saved as a note on the outfit line. */
(function () {
  document.querySelectorAll('[data-included]').forEach(function (group) {
    var out = group.querySelector('[data-a1-included-out]');
    if (!out) return;
    var child = document.querySelector('[data-a1-included-child="' + group.getAttribute('data-collection') + '"]');
    function sync() {
      var checked = group.querySelector('input[type="radio"]:checked');
      var title = checked && checked.value !== '' ? (checked.getAttribute('data-title') || '') : '';
      out.value = title;
      out.disabled = title === '';
      if (child) {
        var sel = child.querySelector('select');
        child.hidden = title === '';
        if (sel) { sel.disabled = title === ''; sel.required = title !== ''; if (title === '') sel.value = ''; }
      }
    }
    group.addEventListener('change', sync);
    sync();
    // An outfit includes these items, so one must be chosen before it can be added to the cart.
    var form = group.closest('form');
    if (form && !form.a1IncludedGuard) {
      form.a1IncludedGuard = true;
      form.addEventListener('submit', function (e) {
        var missing = [].slice.call(form.querySelectorAll('[data-included]')).filter(function (g) { return !g.querySelector('input[type="radio"]:checked:not([value=""])'); })[0];
        if (!missing) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var note = missing.querySelector('.a1-picker__sel');
        var label = (missing.getAttribute('data-included-label') || 'item').toLowerCase();
        if (note) { note.hidden = false; note.className = 'a1-picker__sel a1-picker__sel--error'; note.textContent = 'Please choose a ' + label + ' for your outfit.'; }
        missing.open = true;
        missing.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, true);
    }
  });
})();
